import Input from "../../../../Core/Fields/Floating/Input";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import { useEffect, useState } from "react";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
const Tab2 = ({ SupplierPrimaryAddress, SupplierPrimaryContact, IdData }) => {
	// Helper function to format a single address object into a string.
	const formatAddress = (address) => {
		// Check if the address object and its properties exist before formatting.
		if (!address) return "";

		const name = address.name || "";
		const line1 = address.address_line1 || "";
		const line2 = address.address_line2 || "";
		const city = address.city || "";
		const state = address.state || "";
		const country = address.country || "";
		const pincode = address.pincode || "";

		// Join the city, state, country, and pincode with a comma and space.
		const cityStateCountryPincode = [city, state, country, pincode]
			.filter(Boolean)
			.join(", ");

		return `${name}\n${line1}\n${line2}\n${cityStateCountryPincode}`;
  };
  function formatContacts(contact) {
  // Use the map function to transform each contact object into a formatted string.
    // Extract the required properties from each contact object.
    const email = contact.email_id || "";
    const mobile = contact.mobile_no|| "";
    const phone = contact.phone || ""
    console.log("Contaxttt",contact);
    
    // Use a template literal to construct the formatted string.
    return `Email: ${email}\nMobile: ${mobile}\nPhone: ${phone}`;
}
  
  const [formattedAddresses, setFormattedAddresses] = useState("");
  const [formattedContact, setFormattedContact] = useState("");

  useEffect(() => {
    const adrlist =
      SupplierPrimaryAddress.SupplierPrimaryAddress_list.map(formatAddress);
    const x = adrlist.join("\n\n");
    const contlist =
      SupplierPrimaryContact.SupplierPrimaryContact_list.map(formatContacts);
    const y = contlist.join("\n\n");
    setFormattedAddresses(x);
    setFormattedContact(y)
  }, [SupplierPrimaryContact.SupplierPrimaryContact_list,SupplierPrimaryAddress.SupplierPrimaryAddress_list]); 

	return (
	 <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Primary Address</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                {/* ---- Primary Address ---- */}
            <div style={{ flex: 1 }}>
              {SupplierPrimaryAddress?.SupplierPrimaryAddress_list?.length > 0 ? (
                <>
                  <Textarea
                    label="Primary Address"
                    style={{
                      whiteSpace: "pre-line",
                      backgroundColor: "#f8f6f6"
                    }}
                    value={formattedAddresses}
                    readOnly
                  />
                  <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      lineHeight: "2",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
					  marginTop: "-8px",
                    }}
                  >
                    Reselect, if the chosen address is edited after save
                  </p>
                </>
              ) : (
                <>
                  <Input
                    label="Supplier Primary Address"
                    readOnly
                    value="No Address Linked with Supplier"
                    style={{ height: "30px" }}
                    
                  />
                  <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      lineHeight: "2",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
					  marginTop: "-8px",
                    }}
                  >
                    Reselect, if the chosen contact is edited after save
                  </p>
                </>
              )}
            </div>

              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Primary Contact</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

              
            {/* ---- Primary Contact ---- */}
            <div style={{ flex: 1 }}>
              {SupplierPrimaryContact?.SupplierPrimaryContact_list?.length > 0 ? (
                <>
                  <Textarea
                    label="Primary Contact"
                    style={{
                      whiteSpace: "pre-line",
                      backgroundColor: "#f8f6f6",
                    }}
                    value={formattedContact}
                    readOnly
                  />
                  <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      lineHeight: "2",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
					  marginTop: "-8px",
                    }}
                  >
                    Reselect, if the chosen address is edited after save
                  </p>
                </>
              ) : (
                <>
                  <Input
                    label="Supplier Primary Contact"
                    readOnly
                    value="No Contact Linked with Supplier"
                    style={{ height: "30px" }}
                    
                  />
                  <p
                    style={{
                      paddingLeft: "4px",
                      paddingRight: "14px",
                      fontWeight: 400,
                      fontSize: "9px",
                      lineHeight: "2",
                      letterSpacing: "0",
                      color: "#2C2B31",
                      fontFamily: "Roboto, sans-serif",
					  marginTop: "-8px",
                    }}
                  >
                    Reselect, if the chosen address is edited after save
                  </p>
                </>
              )}
            </div>

              </div>




            </div>
          </div>
        </div>
          <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Supplier" docname={IdData} />
            </div>
          </div>
        </div>
      </div>

    </div>

	);
};

export default Tab2;
